<!-- Copyright (c) ArubaCC - All Rights Reserved. -->
<aup-loader></aup-loader>
<router-outlet></router-outlet>
